"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderableSections = void 0;
/**
 * Returns an array of sections in the desired order, excluding any specified sections.
 */
function getRenderableSections({ defaultSections, sectionOrder, excludedSections, customXPFieldSections }) {
    let sections = [];
    const customSections = customXPFieldSections
        ? customXPFieldSections === null || customXPFieldSections === void 0 ? void 0 : customXPFieldSections.map((customSection) => customSection.id)
        : [];
    if (Array.isArray(sectionOrder)) {
        // use the order as passed in
        sections = [...sectionOrder];
        // and append any section from defaultSections that wasnt in sectionOrder
        defaultSections.forEach((section) => {
            if (!sections.includes(section)) {
                sections.push(section);
            }
        });
        customSections.forEach((section) => {
            if (!sections.includes(section)) {
                sections.push(section);
            }
        });
    }
    else {
        sections = [...defaultSections, ...customSections];
    }
    if (Array.isArray(excludedSections)) {
        // filter out any sections that are in the excludedSections array
        return sections.filter((section) => !excludedSections.includes(section));
    }
    return sections;
}
exports.getRenderableSections = getRenderableSections;
//# sourceMappingURL=ordering.js.map